import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const StudentDetails1 = ({user}) => {
  const [formData, setFormData] = useState({ NAME: '' });
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setFormData({ ...formData, NAME: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch("https://school.agnisofterp.com/agni/testing/entry", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ NAME: formData.NAME })
      });

      const result = await response.json();

      if (result.success === 200) {
        alert("✅ " + result.message);

        // ✅ Pass name to Form 2 using navigate and state
        navigate('/NaviTest', { state: { name: formData.NAME } });
       //window.open(`/NaviTest?name=${encodeURIComponent(formData.NAME)}`, '_blank');
        // Optional: clear the input
        setFormData({ NAME: '' });
      } else {
        alert("❌ Failed to save data");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("⚠️ An error occurred while saving data.");
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: '50px auto', fontFamily: 'Arial' }}>
      <h2>Student Form</h2>

      <input
        type="text"
        name="NAME"
        placeholder="Enter Name"
        value={formData.NAME}
        onChange={handleInputChange}
        autoComplete="off"
        style={{ padding: '10px', width: '100%', marginBottom: '20px' }}
      />

      <button
        onClick={handleSubmit}
        style={{ padding: '10px 20px', backgroundColor: '#007BFF', color: 'white', border: 'none' }}
      >
        Save
      </button>
    </div>
  );
};

export default StudentDetails1;
